import { useEffect } from 'react';

export const useHandleConfigs = (callback: () => void) => {
  useEffect(() => {
    callback();
  }, []);
};
